import { IFormErrorHandler } from "../../../common/Form/FormError";

export const defaultErrorHandler: IFormErrorHandler = {
  match: () => true,
  describe: () => 'There was an error processing the data provided',
}